var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96 11.9599C10.8204 12.8285 9.4327 13.3098 7.99996 13.3332C3.33329 13.3332 0.666626 7.99985 0.666626 7.99985C1.49589 6.45445 2.64605 5.10426 4.03996 4.03985M6.59996 2.82652C7.05885 2.71911 7.52867 2.66541 7.99996 2.66652C12.6666 2.66652 15.3333 7.99985 15.3333 7.99985C14.9286 8.75693 14.446 9.46968 13.8933 10.1265M9.41329 9.41319C9.23019 9.60969 9.00939 9.76729 8.76406 9.8766C8.51873 9.98591 8.25389 10.0447 7.98535 10.0494C7.71681 10.0542 7.45007 10.0048 7.20103 9.90418C6.952 9.80359 6.72577 9.65387 6.53586 9.46396C6.34594 9.27404 6.19622 9.04782 6.09563 8.79878C5.99504 8.54975 5.94564 8.283 5.95038 8.01446C5.95512 7.74592 6.0139 7.48108 6.12321 7.23575C6.23252 6.99042 6.39013 6.76962 6.58663 6.58652",
    stroke: "#ACAFB5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 1.3335L14.6667 14.6668",
    stroke: "#ACAFB5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_1728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.a2aa0898e14fc6de420ab76f0860a1e6.svg";
export { ForwardRef as ReactComponent };